/**
 * Main project card component
 * Used to map all projects located in ./projectsList.tsx
 */
import React from 'react';

// card imports
// import { makeStyles } from '@material-ui/core/styles';
// import Card from '@material-ui/core/Card';
// import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
// import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';

// style imports
import { ProjectCardContent, ProjectContentContainer, ProjectTechnologyIcon } from '../../../styles/sectionStyles/ProjectSectionStyles';

// custom card imports
import {
  ProjectLinkWrapper,
  ProjectCardDiv,
} from '../../../styles/sectionStyles/ProjectSectionStyles';

// tilt effect
import Tilt from 'react-parallax-tilt';

export default function ProjectCard({ projectData }) {
  return (
    <Tilt tiltMaxAngleX={5} tiltMaxAngleY={5}>
      <ProjectLinkWrapper href={projectData.link} aria-label='project-link'>
        <ProjectCardDiv background={projectData.image}>
          <ProjectContentContainer>
            <ProjectCardContent>
              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                  {projectData.title}
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  {projectData.description}
                </Typography>
              </CardContent>
              <CardActions>
                {projectData.technologies.map((icon, key) => {
                  return (<ProjectTechnologyIcon key={key}>{icon}</ProjectTechnologyIcon>)
                })}
              </CardActions>
            </ProjectCardContent>
          </ProjectContentContainer>
        </ProjectCardDiv>
      </ProjectLinkWrapper>
    </Tilt>
  );
}
